import React from 'react';
import { CombatResult } from '../types/GameTypes';
import './CombatResultModal.css';

interface CombatResultModalProps {
  result: CombatResult;
  onClose: () => void;
}

const CombatResultModal: React.FC<CombatResultModalProps> = ({ result, onClose }) => {
  if (!result) return null;

  const { attacker, defender, priority, victor } = result;

  let victorName = 'The battle is a draw.';
  if (victor) {
    victorName = `Player ${victor === attacker.id ? attacker.name : defender.name} is victorious!`;
  }

  const DiceAnimationPlaceholder = ({ roll }: { roll: number[] }) => (
    <div className="dice-placeholder">
      {roll.join(' & ')}
    </div>
  );

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>X</button>
        <h2 className="modal-title">Combat Resolved</h2>
        <div className="combatants">
          <div className="combatant attacker">
            <h3>Attacker (P{attacker.name})</h3>
            <p>Health: {attacker.healthBefore} {'->'} {attacker.healthAfter}</p>
            <div className="dice-roll">
              <p>Roll:</p>
              <DiceAnimationPlaceholder roll={attacker.roll} />
            </div>
            <p>Damage Dealt: {attacker.damage}</p>
          </div>
          <div className="vs">VS</div>
          <div className="combatant defender">
            <h3>{"Defender (P" + defender.name + ")"}</h3>
            <p>Health: {defender.healthBefore} &rarr; {defender.healthAfter}</p>
            <div className="dice-roll">
              <p>Roll:</p>
              <DiceAnimationPlaceholder roll={defender.roll} />
            </div>
            <p>Damage Dealt: {defender.damage}</p>
          </div>
        </div>
        <div className="combat-summary">
          <p><strong>Priority:</strong> {priority === 'attacker' ? 'Attacker' : 'Defender'} wins priority.</p>
          <p><strong>Victor:</strong> {victorName}</p>
        </div>
      </div>
    </div>
  );
};

export default CombatResultModal;
